var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [[_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "6",
      "md": "6",
      "lg": "6",
      "xl": "6"
    }
  }, [_c('inout-product')], 1)], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }